import { CodeBlockElement } from '@typedream/components';
import { DreamBlock, DreamValue } from '@typedream/core';
import { createCodeBlockPlugin as createPlateCodeBlockPlugin } from '@udecode/plate-code-block';
import { PlatePlugin, PluginOptions } from '@udecode/plate-core';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_CODE_BLOCK, ELEMENT_CODE_LINE } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';
import { BaseDreamEditor } from '../../types';

export const createCodeBlockPlugin = createTElementPluginFactory({
  key: ELEMENT_CODE_BLOCK,
  component: withDropTarget(CodeBlockElement),
  // FIXME: fix typing here, maybe shouldn't be using the `as` keyword
  then: () =>
    createPlateCodeBlockPlugin() as unknown as PlatePlugin<
      PluginOptions,
      DreamValue,
      BaseDreamEditor
    >,
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: true,
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/code.png',
      title: 'Code',
      subtitle: 'Add a code snippet',
    },
    format: {
      formatType: 'block',
      focusableWhenEmpty: true,
      changeToParagraphOnBackspace: true,
      insertNode: {
        children: [
          {
            children: [
              {
                text: '',
              },
            ],
            type: ELEMENT_CODE_LINE,
          },
        ],
        type: ELEMENT_CODE_BLOCK,
      } as DreamBlock,
      validProperties: [
        'width',
        'width_max',
        'mobile_hide',
        'desktop_hide',
        'connect_data',
        'margin',
        'border_radius',
        'box_shadow',
      ],
      validChildrenTypes: [ELEMENT_CODE_LINE],
    },
  },
});
